import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { UserEvent } from './user-event.model';

export class FinVacationGardiennageEvent extends UserEvent {
  public static NAME = 'FIN_VACATION_GARDIENNAGE_EVENT';
  constructor(
    public idCreneau: string,
    public fin: dayjs.Dayjs,
    public signature?: string,
    public champsPersonnalises: ChampCompteRendu[] = [],
    coordinates?: Coordinates
  ) {
    super(FinVacationGardiennageEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: FinVacationGardiennageEvent): FinVacationGardiennageEvent {
    return new FinVacationGardiennageEvent(obj.idCreneau, dayjs(obj.fin), obj.signature, obj.champsPersonnalises, obj.coordinates);
  }
}
